module.exports = __webpack_public_path__ + "static/media/blog.84537c73.svg";